import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const ShapeShapesFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M3.6 11.16L7.94 3.7L12.28 11.16H3.6ZM16.2 10.94C14.36 10.94 12.84 9.44 12.84 7.6C12.84 5.76 14.36 4.28 16.2 4.28C18.04 4.28 19.56 5.76 19.56 7.6C19.56 9.44 18.04 10.94 16.2 10.94ZM11.94 16.14L16.2 11.88L20.46 16.14L16.2 20.4L11.94 16.14ZM4.6 19.38V12.9H11.06V19.38H4.6Z" />
    </SvgIcon>
  );
});
